export default __webpack_public_path__ + "static/media/get-access.960d1d6e.png";